import { Component, inject, Input } from "@angular/core";
import { ClientEncounterTypeEligibility } from "app/core/models/client-encounter-type-eligibility.model";
import { DatePipe, NgClass } from "@angular/common";
import { BlankValueDashPipe } from "app/shared/pipes/blank-value-dash.pipe";
import { keyedEncounterTypeEligibilityStatusOptions } from "app/core/options/encounter-type-eligibility-status.opts";
import { EncounterTypeEligibilityStatus } from "app/core/enums/encounter-type-eligibility-status.enum";
import { EncounterTypeEligibilitiesService } from "app/core/services/encounter-type-eligibilities.service";

@Component({
    selector: 'app-client-encounter-type-eligibility-list',
    templateUrl: './client-encounter-type-eligibility-list.component.html',
    styleUrls: ['./client-encounter-type-eligibility-list.component.scss'],
    imports: [NgClass,
              DatePipe,
              BlankValueDashPipe]
})
export class ClientEncounterTypeEligibilityListComponent {
  private encounterTypeEligibilityService = inject(EncounterTypeEligibilitiesService);

  @Input() clientEncounterTypeEligibilities: ClientEncounterTypeEligibility[];

  trackByEligibility = (index: number, eligibility: ClientEncounterTypeEligibility) => {
    return `${eligibility.client.id}-${eligibility.encounterType}`;
  };

  eligibilityStatuses = EncounterTypeEligibilityStatus;
  keyedEligibilityStatusOptions = keyedEncounterTypeEligibilityStatusOptions;

  onMarkEligibleClick(eligibility: ClientEncounterTypeEligibility) {
    this.encounterTypeEligibilityService.markAsEligible(eligibility).subscribe(
      () => eligibility.eligibility = this.eligibilityStatuses.eligible
    );
  }

  onMarkIneligibleClick(eligibility: ClientEncounterTypeEligibility) {
    this.encounterTypeEligibilityService.markAsIneligible(eligibility).subscribe(
      () => eligibility.eligibility = this.eligibilityStatuses.ineligible
    );
  }
}
